import { ReactElement } from "react";
import { useTranslation } from "@pancakeswap/localization";
import styled from "styled-components";
import { AutoColumn, ErrorIcon, Text, Flex, Button } from "../../components";

const Wrapper = styled.div`
  width: 100%;
`;

export function TransactionErrorContent({
  message,
  onDismiss,
}: {
  message: ReactElement | string;
  onDismiss?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <AutoColumn justify="center">
        <img src="images/swap/err.svg" alt="error" />
        <Text color="#fff" style={{ marginTop: "24px", textAlign: "center", width: "85%", wordBreak: "break-word" }}>
          {message}
        </Text>
      </AutoColumn>

      {onDismiss ? (
        <Flex justifyContent="center" pt="24px">
          <ButtonStyle onClick={onDismiss}>{t("Dismiss")}</ButtonStyle>
        </Flex>
      ) : null}
    </Wrapper>
  );
}

const ButtonStyle = styled.button`
  background-color: rgb(46, 129, 255);
  padding: 8px 16px;
  border-radius: 12px;
  box-shadow: none;
  border: none;
  height: 40px;
  width: 100%;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
`;
